import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { LegalConsents } from '../@types/acceptConditions'

export type LegalConsentsStore = LegalConsents & {
  answer?: boolean
}

type Store = {
  consents: LegalConsentsStore[]
  setConsents: (consents: any[]) => void
  updateConsent: (consent: any) => void
}

export const useConsentsStore = create<Store>()(
  devtools(
    (set) => ({
      consents: [],
      setConsents: (consents) => set({ consents }),
      updateConsent: (item) => {
        set((state) => {
          const newData = state.consents?.map((consent) => {
            if (consent?.legalConsentCode === item.legalConsentCode) {
              return { ...consent, ...item }
            } else {
              return consent
            }
          })

          return { consents: newData }
        })
      },
    }),
    { name: 'ConsentsStore' },
  ),
)
